<template>
  <div class="dashboard-layout">
    <template v-if="isLogin">
      <layout>
        <div id="dashboard">
          <router-view />
        </div>
      </layout>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script>
import { isLoggedIn } from "@/services/UserService";
import layout from "@/layouts/DefaultLayout";
import Home from "@/views/Home.vue";

export default {
  name: "dashboard",
  components: {
    layout,
    Home,
  },
  computed: {
    isLogin() {
      return isLoggedIn();
    },
  },
};
</script>

<style lang="scss">
#dashboard {
  background-image: url("../assets/images/bg-dashboard.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-attachment: fixed;
  z-index: 2;

  & > .content {
    min-height: 100vh;
    color: #58595b;
    width: 100%;

    a {
      color: #58595b;
    }
  }
}
</style>
